import { deepPurple } from '@mui/material/colors';
import { Box, Card, Grid, Stack, useTheme, Typography } from '@mui/material';

import { useResponsive } from 'src/hooks/use-responsive';

export const DetailTeacherManageFunction = () => {
  const theme = useTheme();
  const deepPurpleColor = deepPurple.A200;

  const smDown = useResponsive('down', 'sm');
  const padding = () => {
    if (smDown) {
      return 2;
    }
    return 3;
  };
  return (
    <Stack mb={smDown ? 5 : 10}>
      <Stack my={5} spacing={2} alignItems="center">
        <Typography
          fontFamily='"Shantell Sans Light", sans-serif'
          sx={{ color: deepPurpleColor }}
          fontSize={18}
          align="center"
          fontWeight="medium"
        >
          Phần mềm quản lý trung tâm thế hệ mới
        </Typography>
        <Typography variant="h2" align="center">
          Đánh giá giáo viên với CenterUp
        </Typography>
        <Stack>
          <Typography variant="body1" align="center" maxWidth={808}>
            Theo dõi lịch giảng dạy, chấm công và đánh giá giáo viên dễ dàng với phần mềm quản lý
            trung tâm CenterUp – minh bạch năng suất, hỗ trợ tính lương và tối ưu lịch giảng.
          </Typography>
        </Stack>
      </Stack>
      <Stack alignSelf="center" maxWidth={1150}>
        <Grid container justifySelf="center" spacing={4} alignItems="stretch">
          <Grid md={6} sm={12} item>
            <Card
              sx={{
                width: '100%',
                justifySelf: 'center',
                height: '100%',
                background: theme.palette.background.neutral,
                position: 'relative',
              }}
              variant="outlined"
            >
              <Stack height="100%" justifyContent="space-between">
                <Stack zIndex={2} px={padding} pt={padding}>
                  <Typography variant="h5">Theo dõi tiến độ giảng dạy lớp học</Typography>
                  <Typography variant="subtitle2" fontWeight={400}>
                    Theo dõi lớp học có đang dạy đúng chương trình không, cảnh báo tự động khi chậm
                    hoặc thiếu buổi.
                  </Typography>
                </Stack>
                <Stack>
                  <Box
                    component="img"
                    alt="employee-detail"
                    src="/assets/sub-pages/lms/teacher-management/list-class.png"
                    zIndex={2}
                    width="100%"
                    alignSelf="center"
                  />
                </Stack>
              </Stack>
            </Card>
          </Grid>
          <Grid md={6} sm={12} item>
            <Card
              sx={{
                width: '100%',
                justifySelf: 'center',
                height: '100%',
                background: theme.palette.background.neutral,
              }}
              variant="outlined"
            >
              <Stack height="100%" justifyContent="space-between">
                <Stack px={padding} pt={padding}>
                  <Typography variant="h5">
                    Đánh giá hiệu quả giảng dạy theo từng lớp học
                  </Typography>
                  <Typography variant="subtitle2" fontWeight={400}>
                    Theo dõi kết quả học tập tổng thể trong từng lớp – để đánh giá mức độ hiệu quả
                    giảng dạy của giáo viên một cách khách quan, dựa trên dữ liệu thực tế thay vì
                    cảm tính.
                  </Typography>
                </Stack>
                <Stack>
                  <Box
                    alignSelf="flex-end"
                    alt="class-dashboard"
                    component="img"
                    width="100%"
                    src="/assets/sub-pages/lms/teacher-management/perform.png"
                    zIndex={2}
                  />
                </Stack>
              </Stack>
            </Card>
          </Grid>
          <Grid md={6} sm={12} item>
            <Card
              sx={{
                width: '100%',
                justifySelf: 'center',
                height: '100%',
                background: theme.palette.background.neutral,
              }}
              variant="outlined"
            >
              <Stack height="100%" justifyContent="space-between">
                <Stack px={padding} pt={padding}>
                  <Typography variant="h5">Theo dõi công việc theo từng giáo viên</Typography>
                  <Typography variant="subtitle2" fontWeight={400}>
                    Quản lý giao công việc cho giáo viên, theo dõi mức độ hoàn thành – không còn
                    &quot;giao miệng rồi quên&quot;.
                  </Typography>
                </Stack>
                <Stack>
                  <Box
                    component="img"
                    alt="class-task"
                    src="/assets/sub-pages/lms/teacher-management/task-log.png"
                    zIndex={2}
                    width="100%"
                    alignSelf="center"
                  />
                </Stack>
              </Stack>
            </Card>
          </Grid>
          <Grid md={6} sm={12} item>
            <Card
              sx={{
                width: '100%',
                justifySelf: 'center',
                height: '100%',
                background: theme.palette.background.neutral,
              }}
              variant="outlined"
            >
              <Stack height="100%" justifyContent="space-between">
                <Stack px={padding} pt={padding} width={1}>
                  <Typography variant="h5">Theo dõi lịch dạy & chuyên cần</Typography>
                  <Typography variant="subtitle2" fontWeight={400}>
                    Biết rõ ai dạy gì, dạy bao nhiêu giờ mỗi tuần, nghỉ phép hay nghỉ không phép –
                    không cần hỏi thủ công.
                  </Typography>
                </Stack>
                <Stack>
                  <Box
                    component="img"
                    alt="class-schedule"
                    src="/assets/sub-pages/lms/teacher-management/attendance-log.png"
                    zIndex={2}
                    width="100%"
                    alignSelf="center"
                  />
                </Stack>
              </Stack>
            </Card>
          </Grid>
          <Grid md={6} sm={12} item>
            <Card
              sx={{
                width: '100%',
                justifySelf: 'center',
                height: '100%',
                background: theme.palette.background.neutral,
              }}
              variant="outlined"
            >
              <Stack height="100%" justifyContent="space-between">
                <Stack px={padding} pt={padding} width={1}>
                  <Typography variant="h5">Chấm công thông minh, với công nghệ FaceId</Typography>
                  <Typography variant="subtitle2" fontWeight={400}>
                    Tự động ghi nhận công theo lịch dạy, lịch làm việc và nhiệm vụ hoàn thành. Phù
                    hợp cả với giáo viên, nhân viên part-time và cộng tác viên.
                  </Typography>
                </Stack>
                <Stack>
                  <Box
                    component="img"
                    alt="class-schedule"
                    src="/assets/sub-pages/lms/teacher-management/face-id.png"
                    zIndex={2}
                    width="100%"
                    alignSelf="center"
                  />
                </Stack>
              </Stack>
            </Card>
          </Grid>
          <Grid md={6} sm={12} item>
            <Card
              sx={{
                width: '100%',
                justifySelf: 'center',
                height: '100%',
                background: theme.palette.background.neutral,
              }}
              variant="outlined"
            >
              <Stack height="100%" justifyContent="space-between">
                <Stack px={padding} pt={padding} width={1}>
                  <Typography variant="h5">Tính lương tự động</Typography>
                  <Typography variant="subtitle2" fontWeight={400}>
                    Tính lương dựa trên công thực tế, giờ dạy, KPI và quy định thưởng phạt. Tự động
                    hóa hoàn toàn, đồng bộ với hệ thống tài chính.
                  </Typography>
                </Stack>
                <Stack>
                  <Box
                    component="img"
                    alt="class-schedule"
                    src="/assets/sub-pages/lms/teacher-management/salary.png"
                    zIndex={2}
                    width="100%"
                    alignSelf="center"
                  />
                </Stack>
              </Stack>
            </Card>
          </Grid>
        </Grid>
      </Stack>
    </Stack>
  );
};
